import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Slide,
  Snackbar,
  Tooltip,
} from '@material-ui/core';
import { Save as SaveIcon } from '@material-ui/icons';
import { Alert } from '@material-ui/lab';

const useStyles = makeStyles((theme) => ({
  submitButton: {
    margin: theme.spacing(2),
    borderRadius: 50,
    minWidth: 36,
    width: 'auto',
    padding: '6px',
    position: 'relative',
  },
}));

const Transition = React.forwardRef((props, ref) => <Slide direction="up" ref={ref} {...props} />);

// eslint-disable-next-line no-unused-vars
export default function SaveButton({ handleSave }) {
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState('');

  const handleOpen = () => {
    setOpen(true);
  };

  const handleAccept = () => {
    // handleSave();
    setOpen(false);
    setMessage('All modified data has been saved to the database.');
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleSnackbarClose = () => {
    setMessage('');
  };

  return (
    <>
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle id="alert-dialog-slide-title">Do you want to save changes?</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            This action will persist changes done in this table to the database.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Cancel
          </Button>
          <Button variant="contained" onClick={handleAccept} color="primary">
            Save
          </Button>
        </DialogActions>
      </Dialog>
      <Tooltip title="Save Changes">
        <Button
          variant="contained"
          color="primary"
          className={classes.submitButton}
          onClick={handleOpen}
        >
          <SaveIcon />
        </Button>
      </Tooltip>
      <Snackbar open={!!message} autoHideDuration={6000} onClose={handleSnackbarClose}>
        <Alert onClose={handleSnackbarClose} severity="success">{message}</Alert>
      </Snackbar>
    </>
  );
}
